// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__hM2zx","body":"style__body__Z3zFD","footer":"style__footer__fKu5+"};